import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../lib/routes';
import { useTranslation } from '../../hooks/useTranslation';
import FooterAds from '../ads/FooterAds';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white pt-12">
      {/* Required Footer Ads Placement */}
      <FooterAds />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <span className="font-bold text-xl text-gray-900 tracking-tight mb-4 block">hahub</span>
            <p className="text-gray-500 text-sm max-w-md leading-relaxed">
              {t('footer.mission')}
            </p>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
              {t('footer.about')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to={ROUTES.PUBLIC.ABOUT} className="text-sm text-gray-500 hover:text-blue-600">
                  Mission & Values
                </Link>
              </li>
              <li>
                <Link to={ROUTES.PUBLIC.COMMUNITY} className="text-sm text-gray-500 hover:text-blue-600">
                  Community Guidelines
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4">
              Platform
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to={ROUTES.PUBLIC.SUBMIT} className="text-sm text-gray-500 hover:text-blue-600">
                  Submit a Resource
                </Link>
              </li>
              <li>
                <Link to={ROUTES.ADMIN.DASHBOARD} className="text-sm text-gray-500 hover:text-blue-600">
                  Admin Login
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} hahub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;